import React, { useEffect, useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import changeImage from '../../assets/changeImage.png';
import editProf from '../../assets/editProf.png';
import profile from '../../assets/profile.png';
import ImageUploader from 'react-images-upload';

export default function AddKategoriFAQ(props) {

    const [nama, setNama] = useState("")
    const [facility, setFacility] = useState(null)
    const [remark, setRemark] = useState("")
    const [time, setTime] = useState(null)
    const [image, setImage] = useState([profile])
    const [uploadVisible, setUploadVisible] = useState(false)
    const [photo, setPhoto] = useState("")
    const [pictures, setPicture] = useState([])
    const listType = [
        { value: "Mobile" },
        { value: "KIOSK" },
    ]
    const [pickType, setPickType] = useState(null)

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleSave = () => {
        let pic = pictures[0]
        let formData = new FormData()
        formData.append('type', pickType.value)
        formData.append('category', nama)
        if (pic !== undefined) {
            formData.append('icon', pic)
        }
        props.createKategori(formData)
    }

    const onDrop = (pictureFiles, pictureDataURLs) => {
        console.log(pictureFiles, pictureDataURLs);
        setPhoto(pictureDataURLs)
        setPicture(pictureFiles)
    }

    const uploadFoto = () => {
        setUploadVisible(false)
    }

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Tambah Kategori Baru</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div style={{ margin: 'auto', width: 134, height: 134, backgroundColor: photo === "" ? 'green' : 'transparent', marginTop: 20, borderRadius: 80 }}>
                    <img src={photo === "" ? image : photo} style={{ width: 126, height: 126, marginTop: 3, borderRadius: 60 }} />
                    <div style={{ marginTop: -19, marginLeft: 7 }}>
                        <img src={changeImage} style={{ width: 102, height: 24, marginRight: 8 }} />
                        <img src={editProf} style={{ width: 18.6, height: 18.6, marginTop: -45, cursor: 'pointer' }}
                            onClick={(e) => {
                                setPicture("")
                                setUploadVisible(true)
                            }}
                        />
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <div className="">
                            <Autocomplete
                                options={listType}
                                getOptionLabel={(option) => option.value}
                                disableClearable
                                // debug 
                                id="tipe"
                                onChange={(event, newInputValue) => {
                                    setPickType(newInputValue)
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                        label="Tipe"
                                    />
                                }
                            />
                        </div>
                        {/* <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="remark"
                                name="remark"
                                label="Remark"
                                placeholder={"input Remark"}
                                onChange={(e) => {
                                    setRemark(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div> */}
                    </div>
                    <div className="column-2">
                        <div style={{}}>
                            <TextField
                                style={{ width: '100%' }}
                                id="nama"
                                name="nama"
                                label="Nama Kategori"
                                placeholder={"input Nama Kategori"}
                                onChange={(e) => {
                                    setNama(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => handleSave()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>

            {uploadVisible && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setUploadVisible(false)
                                        setPicture("")
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <ImageUploader
                            withIcon={true}
                            withPreview
                            buttonStyles={pictures.length > 0 ? { display: 'none' } : null}
                            buttonText={'Select Picture'}
                            onChange={onDrop}
                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                            maxFileSize={1000000}
                            label={"Max file size: 1 Mb, accepted: jpg or png"}
                        />
                        {pictures.length > 0 ?
                            <div style={{ display: 'grid', margin: 20 }}>
                                <div style={{ justifySelf: 'center' }}>
                                    <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => uploadFoto()}>Upload</span>
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            )}
        </div>
    )
}